import React from 'react';
import { cn } from '@/lib/utils';
import { PublicMinimalFooter } from './PublicMinimalFooter';
import '../../styles/auth-page.css';

/**
 * Shared centred layout for login / register / password flows.
 * Presentation only — no auth logic.
 */
export function AuthPageLayout({ children, className }) {
  return (
    <div className={cn('auth-page', className)}>
      <div className="auth-page__noise noise-overlay" aria-hidden />
      <div className="auth-page__frame">
        <main className="auth-page__main">
          <div className="auth-page__stack">{children}</div>
        </main>
        <PublicMinimalFooter />
      </div>
    </div>
  );
}

export default AuthPageLayout;
